import { render } from "./TablaServiciosProgramados.vue?vue&type=template&id=2f1a9356&ts=true"
import script from "./TablaServiciosProgramados.vue?vue&type=script&lang=ts"
export * from "./TablaServiciosProgramados.vue?vue&type=script&lang=ts"

import "./TablaServiciosProgramados.vue?vue&type=style&index=0&id=2f1a9356&lang=scss"

import exportComponent from "/opt/build/repo/front-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__